// web_components/wcAccordion/wcAccordion_Renderer.ts

/**
 * Generates the HTML for the wc-accordion component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-accordion">
            <h2 class="wc-accordion__heading">${variables.heading}</h2>
            <details class="wc-accordion__details">
                <summary class="wc-accordion__item-heading">${variables.item1Heading}</summary>		
                <p class="wc-accordion__item-content">${variables.item1Content}</p>
            </details>
            <details class="wc-accordion__details">
                <summary class="wc-accordion__item-heading">${variables.item2Heading}</summary>		
                <p class="wc-accordion__item-content">${variables.item2Content}</p>
            </details>
            <details class="wc-accordion__details">
                <summary class="wc-accordion__item-heading">${variables.item3Heading}</summary>		
                <p class="wc-accordion__item-content">${variables.item3Content}</p>
            </details>
            <details class="wc-accordion__details">
                <summary class="wc-accordion__item-heading">${variables.item4Heading}</summary>		
                <p class="wc-accordion__item-content">${variables.item4Content}</p>
            </details>
            <details class="wc-accordion__details">
                <summary class="wc-accordion__item-heading">${variables.item5Heading}</summary>		
                <p class="wc-accordion__item-content">${variables.item5Content}</p>
            </details>
        </section>
    `;
}
